import {
  TableCell,
  TableRow
} from '@mui/material';
import numeral from 'numeral';


const TableRowItem = (props: any) => {

  return (
    <TableRow hover tabIndex={-1} role="checkbox">
      <TableCell sx={{ fontWeight: 700, color: "#2D60FF" }} align="left">{props.place}</TableCell>
      <TableCell align="center" >{props.user?.id}</TableCell>
      <TableCell align="center" >{props.user?.displayName}</TableCell>
      <TableCell align="center">{numeral(props.totalRedeemedTickets).format("0,000")}</TableCell>
    </TableRow>
  );
}

export default TableRowItem;
